import { useMutation } from '@apollo/client';
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
  Stack,
} from '@fluentui/react';
import { cutToast } from 'utility/toast';
import { EntityDeleteInput } from 'common/types/globalTypes';
import USER_RANK_DELETE from './UserRankDelete.graphql';
import {
  UserRankDelete,
  UserRankDeleteVariables,
} from './__generated__/UserRankDelete';

export const RankOptionDelete: React.FC<{
  rankDeleteEntity: EntityDeleteInput;
  onClose: () => void;
  setRankDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ rankDeleteEntity, setRankDeleteDialog, onClose }) => {
  const [deleteUserRank] = useMutation<UserRankDelete, UserRankDeleteVariables>(
    USER_RANK_DELETE,
    { errorPolicy: 'all' }
  );
  const onDelete = async () => {
    const { errors } = await deleteUserRank({
      variables: {
        input: {
          entityDelete: [
            {
              id: rankDeleteEntity.id!,
              rowTimestamp: rankDeleteEntity.rowTimestamp!,
            },
          ],
        },
      },
      update(cache, { data: response }) {
        response?.userRankDelete?.deletedEntities?.forEach((item) => {
          const identity = `UserRankType:${item?.id}`;
          cache.evict({ id: identity });
          cache.gc();
        });
      },
    });
    if (errors?.length) cutToast.error(`${errors[0].message}`);
    else {
      onClose();
      cutToast.success('User rank deleted successfully');
    }
  };
  return (
    <Stack style={{ height: 100 }}>
      <Dialog
        hidden={false}
        onDismiss={() => {}}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Delete User Rank',
          subText: 'Are you sure you want to delete this user rank?',
        }}
      >
        <DialogFooter>
          <PrimaryButton onClick={onDelete} text="Delete" />
          <DefaultButton
            onClick={() => {
              setRankDeleteDialog(false);
            }}
            text="Cancel"
          />
        </DialogFooter>
      </Dialog>
    </Stack>
  );
};
